var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MenusContainer',{attrs:{"menus":_vm.permissionMenus,"show-menu":!_vm.isFromWorkbench,"app":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }